import React from "react";
import "../CSS/Commercial.css";
import { Link } from "react-router-dom";

const Commercial = () => {
  return (
    <section className="commercial-apostille-page">
      <div className="commercial-apostille-banner">
        <h1 className="commercial-apostille-banner-title">
          Commercial Document Apostille Service in Mumbai
        </h1>

        <p className="commercial-apostille-breadcrumb">
          <Link to="/">Home</Link> &gt;
          <span> Commercial Document Apostille Service</span>
        </p>
      </div>

      <div className="commercial-apostille-layout">
        <aside className="commercial-apostille-sidebar">
          <div className="commercial-apostille-sidebox">
            <h3 className="commercial-apostille-sidebox-title">
              APOSTILLE SERVICES
            </h3>
            <ul className="commercial-apostille-side-list">
              <li className="commercial-apostille-side-item">
                Educational Document Apostille
              </li>
              <li className="commercial-apostille-side-item">
                Personal Document Apostille
              </li>
              <li className="commercial-apostille-side-item">
                Commercial Document Apostille
              </li>
            </ul>
          </div>

          <div className="commercial-apostille-sidebox">
            <h3 className="commercial-apostille-sidebox-title">QUICK LINKS</h3>
            <ul className="commercial-apostille-side-list">
              <li className="commercial-apostille-side-item">
                Apostille Services in Mumbai
              </li>
              <li className="commercial-apostille-side-item">
                Document Apostille Process
              </li>
              <li className="commercial-apostille-side-item">
                MEA Approved Universities
              </li>
              <li className="commercial-apostille-side-item">
                Apostille Country List
              </li>
              <li className="commercial-apostille-side-item">
                Non Apostille Country List
              </li>
              <li className="commercial-apostille-side-item">
                Apostille Accepted Embassy List
              </li>
              <li className="commercial-apostille-side-item">
                Apostille Member Countries
              </li>
              <li className="commercial-apostille-side-item">
                Apostille Centers – Mumbai
              </li>
            </ul>
          </div>
        </aside>

        <main className="commercial-apostille-content">
          <h2 className="commercial-apostille-main-title">
            Commercial Document Apostille in Mumbai for Export Documents
          </h2>

          <p className="commercial-apostille-text">
            Commercial document apostille in Mumbai is required when a company or
            business needs to use export documents in foreign countries. A
            commercial document is a customs or trade document used during
            international business transactions.
          </p>

          <p className="commercial-apostille-text">
            These documents are issued by companies involved in import-export
            activities and contain important details such as the exporter, buyer,
            shipment details, country of origin and product information.
          </p>

          <p className="commercial-apostille-text">
            Businesses in Mumbai often require apostille services for commercial
            documents when exporting goods or services to countries that are
            members of the Hague Apostille Convention.
          </p>

          <p className="commercial-apostille-text">
            <strong>NOTE:</strong> Some countries may require embassy attestation
            along with apostille. Our apostille consultants in Mumbai can guide
            you through the correct legalization process.
          </p>

          <p className="commercial-apostille-highlight-link">
            List of Countries That Require Apostille
          </p>

          <h3 className="commercial-apostille-section-title">
            Commercial Document Apostille Services in Mumbai
          </h3>

          <p className="commercial-apostille-text">
            We provide professional commercial document apostille services in
            Mumbai for companies, exporters and corporate clients. Our team
            handles the complete apostille process through the Ministry of
            External Affairs (MEA).
          </p>

          <p className="commercial-apostille-text">
            Our apostille service includes document verification, notarization,
            chamber of commerce attestation and final MEA apostille depending on
            the document type.
          </p>

          <p className="commercial-apostille-text">
            We also provide doorstep document pickup and delivery services in
            Mumbai, making the apostille process easy and hassle-free for
            businesses.
          </p>

          <p className="commercial-apostille-text">
            For more information call us at +91-8589 008 001 / +91-8588 808 183
            or email us at care@vizatt.in.
          </p>

          <p className="commercial-apostille-text">
            Call +91 8750-388-388 for free document pick-up and drop service in
            Mumbai.
          </p>

          <p className="commercial-apostille-text">
            For details about regional apostille centers and authorities
            <span className="commercial-apostille-highlight-link"> Click Here</span>
          </p>

          <h3 className="commercial-apostille-section-title">
            MEA Apostille Process for Commercial Documents
          </h3>

          <p className="commercial-apostille-text">
            The apostille process for commercial documents in Mumbai involves
            multiple verification steps before the final apostille stamp is
            issued by the Ministry of External Affairs (MEA), Government of India.
          </p>

          <p className="commercial-apostille-text">
            Documents are first verified by authorized bodies such as the Chamber
            of Commerce or relevant authorities depending on the document type.
          </p>

          <p className="commercial-apostille-text">
            After verification, the documents are submitted to the Ministry of
            External Affairs for apostille certification so they can be legally
            used in foreign countries.
          </p>

          <p className="commercial-apostille-text">
            Our apostille experts in Mumbai ensure fast, reliable and secure
            document legalization for all commercial and export documents.
          </p>

          <h2 className="commercial-apostille-main-title">Document Apostille</h2>

          <p className="commercial-apostille-doc-intro">
            Please find the list of commercial document that can be apostilled.
            If your desired document is not listed in the list contact us
            directly at +91-8589 008 001 / +91-8588 808 183.
          </p>

          <h3 className="commercial-apostille-section-title">
            Export Invoice Apostille
          </h3>
          <div className="commercial-apostille-table-wrap">
            <table className="commercial-apostille-table">
              <tbody>
                <tr>
                  <td className="commercial-apostille-table-title">
                    Document Checklist
                  </td>
                  <td>
                    1. Original export certificate <br />
                    2. Passport copy <br />
                    3. Letter head
                  </td>
                </tr>
                <tr>
                  <td className="commercial-apostille-table-title">
                    Processing Time
                  </td>
                  <td>2-3 Working days</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="commercial-apostille-doc-desc">
            An export invoice issued by Indian companies, trade institutions or
            proprietorship firms is eligible for apostille attestation. Normally
            it takes 2-3 working days for authentication with apostille stamping.
          </p>

          <h3 className="commercial-apostille-section-title">
            Certificate Of Origin Apostille
          </h3>
          <div className="commercial-apostille-table-wrap">
            <table className="commercial-apostille-table">
              <tbody>
                <tr>
                  <td className="commercial-apostille-table-title">
                    Document Checklist
                  </td>
                  <td>
                    1. Certificate of Origin original <br />
                    2. Passport copy <br />
                    3. Letter head
                  </td>
                </tr>
                <tr>
                  <td className="commercial-apostille-table-title">
                    Processing Time
                  </td>
                  <td>2-3 Working days</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="commercial-apostille-doc-desc">
            Certificate of Origin issued by Indian companies or trade
            institutions is eligible for apostille attestation. Normally it
            takes 2-3 working days for apostille authentication.
          </p>

          <h3 className="commercial-apostille-section-title">
            Affidavits Apostille
          </h3>
          <div className="commercial-apostille-table-wrap">
            <table className="commercial-apostille-table">
              <tbody>
                <tr>
                  <td className="commercial-apostille-table-title">
                    Document Checklist
                  </td>
                  <td>
                    1. Original Affidavit <br />
                    2. Passport copy
                  </td>
                </tr>
                <tr>
                  <td className="commercial-apostille-table-title">
                    Processing Time
                  </td>
                  <td>2-3 Working days</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="commercial-apostille-doc-desc">
            An affidavit prepared by a notary public or an advocate can be
            apostilled. The candidate must provide the original affidavit and
            passport copy for apostille.
          </p>

          <h3 className="commercial-apostille-section-title">
            Power Of Attorney Apostille
          </h3>
          <div className="commercial-apostille-table-wrap">
            <table className="commercial-apostille-table">
              <tbody>
                <tr>
                  <td className="commercial-apostille-table-title">
                    Document Checklist
                  </td>
                  <td>
                    1. Original power of attorney <br />
                    2. Passport copy
                  </td>
                </tr>
                <tr>
                  <td className="commercial-apostille-table-title">
                    Processing Time
                  </td>
                  <td>2-3 Working days</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3 className="commercial-apostille-section-title">
            Certificate Of Incorporation Apostille
          </h3>
          <div className="commercial-apostille-table-wrap">
            <table className="commercial-apostille-table">
              <tbody>
                <tr>
                  <td className="commercial-apostille-table-title">
                    Document Checklist
                  </td>
                  <td>
                    1. Original incorporation certificate <br />
                    2. Passport copy
                  </td>
                </tr>
                <tr>
                  <td className="commercial-apostille-table-title">
                    Processing Time
                  </td>
                  <td>2-3 Working days</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="commercial-apostille-doc-desc">
            Original incorporation certificate issued by the state government is
            eligible for apostille attestation. Candidates are required to
            produce the original incorporation certificate along with passport
            copy. Normally it takes 2-3 working days for apostille authentication.
          </p>

          <h3 className="commercial-apostille-section-title">
            Chemical Analysis Report
          </h3>
          <div className="commercial-apostille-table-wrap">
            <table className="commercial-apostille-table">
              <tbody>
                <tr>
                  <td className="commercial-apostille-table-title">
                    Document Checklist
                  </td>
                  <td>
                    1. Original Analysis report <br />
                    2. Passport copy
                  </td>
                </tr>
                <tr>
                  <td className="commercial-apostille-table-title">
                    Processing Time
                  </td>
                  <td>2-3 Working days</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="commercial-apostille-doc-desc">
            Original analysis certificate issued by state government, UT
            laboratories or registered laboratories is eligible for apostille
            attestation. Candidates must provide the original analysis report and
            passport copy. Normally the process takes 2-3 working days.
          </p>

          <h3 className="commercial-apostille-section-title">
            Physical Analysis Report
          </h3>
          <div className="commercial-apostille-table-wrap">
            <table className="commercial-apostille-table">
              <tbody>
                <tr>
                  <td className="commercial-apostille-table-title">
                    Document Checklist
                  </td>
                  <td>
                    1. Original Analysis report <br />
                    2. Passport copy
                  </td>
                </tr>
                <tr>
                  <td className="commercial-apostille-table-title">
                    Processing Time
                  </td>
                  <td>2-3 Working days</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="commercial-apostille-doc-desc">
            Original analysis certificate issued by state government, UT
            laboratories or registered laboratories is eligible for apostille
            attestation. Candidates must provide the original analysis report and
            passport copy. Normally it takes 2-3 working days to complete the
            apostille authentication.
          </p>
        </main>
      </div>
    </section>
  );
};

export default Commercial;